const styleProps = {
  button: {
    color: 'current',
    size: 'md',
    variant: 'outline',
  },
};

export default styleProps;
